import React from 'react';
import { View, StyleSheet } from 'react-native';
import {
  SkeletonGroup,
  SkeletonBone,
  SkeletonCircle,
  SkeletonCard,
  SkeletonList,
} from '@/components/common/skeleton';
import { useThemeColors } from '@/hooks/residents/useThemeColors';

const SKELETON_COUNT = 4;

const SingleCardSkeleton: React.FC<{ cardBg: string; cardBorder: string; separator: string }> = ({ cardBg, cardBorder, separator }) => (
  <SkeletonCard
    backgroundColor={cardBg}
    borderColor={cardBorder}
    padding={18}
    borderRadius={16}
  >
    {/* Author row: avatar + name/timestamp */}
    <View style={styles.authorRow}>
      <SkeletonCircle size={32} />
      <View style={styles.authorInfo}>
        <SkeletonBone width={100} height={13} />
        <SkeletonBone width={60} height={11} />
      </View>
      <SkeletonBone width={28} height={28} borderRadius={8} />
    </View>
    {/* Title */}
    <SkeletonBone width="75%" height={16} />
    {/* Body lines */}
    <SkeletonBone width="100%" height={12} />
    <SkeletonBone width="65%" height={12} />
    {/* Tag badge */}
    <SkeletonBone width={64} height={22} borderRadius={5} />
    {/* Footer with separator */}
    <View style={[styles.footerSeparator, { backgroundColor: separator }]} />
    <View style={styles.statsRow}>
      <SkeletonBone width={36} height={14} borderRadius={4} />
      <SkeletonBone width={36} height={14} borderRadius={4} />
    </View>
  </SkeletonCard>
);

export const ThreadCardSkeleton: React.FC = () => {
  const { colors } = useThemeColors();

  return (
    <SkeletonGroup style={styles.container}>
      <SkeletonList count={SKELETON_COUNT} gap={16}>
        <SingleCardSkeleton
          cardBg={colors.card.bg}
          cardBorder={colors.card.border}
          separator={colors.separator}
        />
      </SkeletonList>
    </SkeletonGroup>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 16,
  },
  authorRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    marginBottom: 2,
  },
  authorInfo: {
    flex: 1,
    gap: 3,
  },
  footerSeparator: {
    height: 1,
    marginTop: 4,
  },
  statsRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
  },
});
